import { createSlice } from '@reduxjs/toolkit';
import { updateLocalStorageToken, logOut } from "../../../../../../containers/resources/utils";
import axios from 'axios';

export const avalabilityReportSlice = createSlice({
  name: 'avalabilityReport',
  initialState: {
    items: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateAvalabilityReport(state, action) {
      return {
        items: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesAvalabilityReport(state, action) {
      return {
        items: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    processAvalabilityReport(state, action) {
      return {
        items: [],
        processing: true,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchAvalabilityReportSuccess(state, action) {
      return {
        items: action.payload,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchAvalabilityReportError(state, action) {
      return {
        items: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchAvalabilityReportReport = (yachtId, startDate, endDate) => dispatch => {
  dispatch(processAvalabilityReport());
  var url = `availability/report?yacht_id=${yachtId}&&startDate=${startDate}&&endDate=${endDate}`;
  
  axios.get(`/${url}`, { responseType: 'blob' }) // 👈 importante
    .then(response => {
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", "Disponibilidad.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        dispatch(fetchAvalabilityReportSuccess("Descarga completada"));
      } else if (response.data.code === 202) {
        updateLocalStorageToken(response.data.token);
        dispatch(fetchAvalabilityReportReport(yachtId, startDate, endDate));
      } else if (response.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchAvalabilityReportError(response.data));
      }
    })
    .catch((error) => {
      dispatch(fetchAvalabilityReportError(error));
    });
};


export const {
  initialStateAvalabilityReport,
  requesAvalabilityReport,
  processAvalabilityReport,
  fetchAvalabilityReportSuccess,
  fetchAvalabilityReportError,
} = avalabilityReportSlice.actions;

export default avalabilityReportSlice.reducer;